import { GET_INTERNATIONAL_WASH_REQUEST, GET_INTERNATIONAL_WASH_SUCCESS, GET_INTERNATIONAL_WASH_ERROR } from "./types.js"
import { BASEURL } from "../../constant/config.js"
import axios from "axios";

export const getInternationalWash = (token) => dispatch => {
    dispatch({ type: GET_INTERNATIONAL_WASH_REQUEST });
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/InternationalWash`,
        headers: {
            Accept: "application/json",
            'Authorization': 'Bearer ' + token
        }
    })
        .then(response => {

            return dispatch({ type: GET_INTERNATIONAL_WASH_SUCCESS, payload: response.data });
        })
        .catch((error) => {
            return dispatch({
                type: GET_INTERNATIONAL_WASH_ERROR,
                payload: error.response,
            });
        })
}

